import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const contactItems = [
  {
    icon: <MapPin size={24} />,
    title: "Location",
    content: (
      <>
        Ground Floor, Plot no. 3, Hi-tech Park, <br />
        Pandesara, Surat-394221, Gujarat, India.
      </>
    ),
  },
  {
    icon: <Phone size={24} />,
    title: "Call us",
    content: (
      <>
        Phone : +91 90161 40083 <br />
        Phone : +91 90818 17755
      </>
    ),
  },
  {
    icon: <Mail size={24} />,
    title: "Email us",
    content: (
      <>
        headconnect@thermocraft.co.in <br />
        support@thermocraft.co.in
      </>
    ),
  },
  {
    icon: <Clock size={24} />,
    title: "Working Hour",
    content: (
      <>
        Mon - Sat : 10AM - 08PM <br />
        Sun : Close
      </>
    ),
  },
];

const ContactDetails = () => {
  return (
    <div className="flax-col gap-3">
      <p className="section-title">Get in touch</p>
      <h2 className="text-3xl md:text-4xl font-bold text-primary-200">
        We would love to hear from you.
      </h2>
      <p className="text-gray-600">
        Whether you're looking for customized thermocol solutions or have
        questions about bulk orders, our team is ready to assist you. Let’s talk
        packaging!
      </p>

      <div className="flex flex-col gap-6 border-t pt-6">
        {contactItems.map((item, index) => (
          <div key={index} className="flex items-start gap-4">
            <div className="bg-blue-100 text-white p-3 rounded-full">
              {item.icon}
            </div>
            <div className="flex flex-col gap-1">
              <h4 className="font-semibold text-lg text-text_color-200">
                {item.title}
              </h4>
              <p className="text-text_color-100">{item.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactDetails;
